import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Couplendar - Track Chores & Build Equal Relationships for Couples',
  description = 'Track daily chores, time-off, and contributions with your partner. Build stronger, more balanced relationships through transparency and shared responsibility.',
  keywords = 'couple chore tracker, relationship balance app, shared responsibility, household chores, couple calendar, relationship equality, domestic labor tracker, mental load, fair division of labor',
  image = 'https://couplendar.com/og-image.png',
  url = 'https://couplendar.com',
  type = 'website'
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;
